import {
    HorizAlignment,
    ISearch,
    ISearchProfile,
    ISearchProvider, ISearchProviderField, ISearchRequestSubset,
    SearchProviderFieldType
} from "../PA.UIM.Core/PA.UIM.Core.IF.Search"
import {SearchUtils} from "../PA.UIM.Core/SearchUtils";
import {PASearch, ISearchRequest} from "../PA.Core/PASearch";
import {PAEnvironment} from "../PA.Core/PAEnvironment";

const vUI_Customer_Search_Fields: {[id:string]: ISearchProviderField } =
    {
        WB_CUST_ID:             {type: SearchProviderFieldType.number, renderOptions: { columnName: 'Customer WB Id',  columnResourceName: 'colCustWBId',      alignment: HorizAlignment.Center}, domainOptions: { }},
        CUSTOMER_ID:            {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Id',     columnResourceName: 'colCustId',        alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        CUSTOMER_NAME:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Customer Name',   columnResourceName: 'colCustName',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 256}},
        CUSTOMER_TYPE:          {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Level',           columnResourceName: 'colLevel',         alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        CONSUMPTION_IND:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Cons Ind',        columnResourceName: 'colConsInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
        SHIPMENT_IND:           {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Ship Ind',        columnResourceName: 'colShipInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
        PLANNING_CUSTOMER_IND:  {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Ind',    columnResourceName: 'colPlanInd',       alignment: HorizAlignment.Center}, domainOptions: { maxLength: 5}},
        PLANNED_PERIODS:        {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planned Periods', columnResourceName: 'colPlannedPeriod', alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        SOURCE_ID:              {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Source Id',       columnResourceName: 'colSourceId',      alignment: HorizAlignment.Left},   domainOptions: { maxLength: 50}},
        CREATED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Created Date',
                columnResourceName: 'colCreateDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        },
        MODIFIED_DTTS: {
            type: SearchProviderFieldType.sapdate,
            renderOptions: {
                columnName: 'Modified Date',
                columnResourceName: 'colModifiedDt',
                alignment: HorizAlignment.Center,
                dateFormat: "MM-dd-yy"
            },
            domainOptions: {}
        }
    }

const CustomerSearchProviderBasic: ISearchProvider =
    {
        keyFields: {id:    'WB_CUST_ID',
            id_ui: 'CUSTOMER_ID',
            name:  'CUSTOMER_NAME'},


        searchProviderFields: vUI_Customer_Search_Fields,

        search(searchOptions: ISearchRequestSubset): Promise<any[]> {
            return new Promise<any[]>((resolve, error) => {

                let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                    'vUI_Customer_Search',
                    this.searchProviderFields,
                    [])
                findRequest.where = {'CUSTOMER_TYPE': 'External'};
                PASearch.findByRequest(findRequest)
                    .then((res: any[]) => {
                        resolve(res)
                    })
                    .catch((err)=> {
                        error(err)
                    })
            })
        }

    }

const CustomerSearchProviderPlanned: ISearchProvider = {

    keyFields: {id:    'WB_CUST_ID_PLANNING',
        id_ui: 'WB_CUST_ID_PLANNING',
        name:  'PLANNING_CUSTOMER_NAME'
    },

    searchProviderFields: {
        PLANNING_CUSTOMER_NAME:     {type: SearchProviderFieldType.string, renderOptions: { columnName: 'Planning Level',    columnResourceName: 'colPlanningLevelName', alignment: HorizAlignment.Left}, domainOptions: { maxLength: 256}},
        WB_CUST_ID_PLANNING:     {type: SearchProviderFieldType.number}
    },

    search(searchOptions: ISearchRequestSubset): Promise<any[]> {
        return new Promise<any[]>((resolve, error) => {

            let findRequest = SearchUtils.makeSearchRequest(searchOptions,
                'vUI_Plan_Search',
                this.searchProviderFields,
                ['WB_CUST_ID_PLANNING','PLANNING_CUSTOMER_NAME'])

            SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID_PLANNING')

            PASearch.findByRequest(findRequest)
                .then((res: any[]) => {
                    resolve(res)
                })
                .catch((err)=> {
                    error(err)
                })
        })
    }




}

const MyPlanningCustomerSearchProvider: ISearchProvider = {

    keyFields: {id:    'WB_CUST_ID',
        id_ui: 'CUSTOMER_ID',
        name:  'CUSTOMER_NAME'},


    searchProviderFields: vUI_Customer_Search_Fields,

    search(aRequestSubset: ISearchRequestSubset): Promise<any[]> {

        return new Promise<any[]>((resolve, error) => {

            let findRequest: ISearchRequest
                = SearchUtils.makeSearchRequest(aRequestSubset,
                'vUI_Customer_Search',
                this.searchProviderFields)

            SearchUtils.addUsrContextCustomerFilter(findRequest, 'WB_CUST_ID')

            PASearch.findByRequest(findRequest)
                .then((results: any[]) => {
                    resolve(results)
                })
                .catch((err) => {
                    error(err)
                })
        })
    }

}


const CustomerSearchProfileByName: ISearchProfile = {
    profileId: "default",
    profileName: "Search by Id, Name",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileByName" },

    profileFilter: [
        {profileFilterName: 'Customer Id',     searchProviderFieldId: 'CUSTOMER_ID',   renderOptions: { }},
        {profileFilterName: 'Customer Name',   searchProviderFieldId: 'CUSTOMER_NAME', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_TYPE','CONSUMPTION_IND','SHIPMENT_IND','PLANNING_CUSTOMER_IND','PLANNED_PERIODS',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const CustomerSearchProfileBySource: ISearchProfile = {
    profileId: "BySource",
    profileName: "Search by Source",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileBySource" },

    profileFilter: [
        {profileFilterName: 'Source',     searchProviderFieldId: 'SOURCE_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_TYPE','SOURCE_ID',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}


const MyPlanningCustomers: ISearchProfile = {
    profileId: "MyPlanningCustomers",
    profileName: "My Planning Customers",
    renderOptions: { ui5ResourceId: "MyPlanningCustomers" },

    profileFilter: [
    ],  // ISearchFields
    profileDisplayFields: [
        'PLANNING_CUSTOMER_NAME',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderPlanned,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}
const CustomerSearchProfileByWholeSaler: ISearchProfile = {
    profileId: "ByWholeSaler",
    profileName: "Search by Whole Saler",
    renderOptions: { ui5ResourceId: "CustomerSearchProfileByWholeSaler" },

    profileFilter: [
        {profileFilterName: 'Whole Saler',     searchProviderFieldId: 'WB_CUSTRPG_ID', renderOptions: { }}
    ],  // ISearchFields
    profileDisplayFields: [
        'CUSTOMER_ID','CUSTOMER_NAME','CUSTOMER_TYPE','WB_CUSTRPG_ID',
        'CREATED_DTTS', 'MODIFIED_DTTS'
    ], //string[];   // Search Provider Field Name (Use to Generate Grid Columns)

    profileSearchProvider: CustomerSearchProviderBasic,

    // Do sorting last.. not necessary for phase 1
    profileSortIdDefault: "",    //string;
    profileSorts: [] //ISearchSort[];
}

const CustomerExternalSearch: ISearch = {
    searchName: "Find Customer",
    renderOptions: { ui5ResourceId: "CustomerExternalSearch"},
    searchProfileIdDefault: "default",
    searchProfiles: [CustomerSearchProfileByName, MyPlanningCustomers, CustomerSearchProfileBySource, CustomerSearchProfileByWholeSaler]
}
PAEnvironment.registerBusinessObjectSearch("CustomerBO", "Customer", CustomerExternalSearch, "External Customer Search")
export {CustomerExternalSearch}